<template>
    <div class="wrap-insigths-details">
        <header-app></header-app>
        <div class="insigths-banner"></div>
        <div class="wrap-details">
            <div class="insigths-details">
                <h3 class="details-title">{{info.title}}</h3>
                <div class="info" v-html="info.content"></div>
            </div>
            <bottom-app></bottom-app>
            <top-scroll></top-scroll>
        </div>
    </div>
</template>

<script>
    import headerApp from '@/components/headerApp.vue'
    import bottomApp from '@/components/bottomApp.vue'
    import topScroll from '@/components/topScroll.vue'
    export default {
        components: {
            headerApp,
            bottomApp,
            topScroll
        },
        data(){
            return{
                insigthsList:[],
                id:0,
                info:{}
            }
        },
        created(){
            this.id = this.$route.query.id || 0
            this.$api.insightdetail(this.id).then((res)=>{
                if(res){
                    this.info = res || {}
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-insigths-details{
        text-align: left;
        .insigths-banner{
            height: 3rem;
            background: url("../../assets/imgs/tp-news-bg.png") no-repeat top center;
            background-size:cover;
            position: relative;
        }
        .wrap-details{
            position: absolute;
            left: 0;
            top: 2rem;
            padding: 0 .5rem;
            width: 100%;
            box-sizing: border-box;
        }
        .insigths-details{
            background: #fff;
            padding-bottom: 1rem;
            .details-title{
                font-size: 0.3rem;
                color: #6b6b6b;
                line-height: .36rem;
                font-weight: bold;
                position: relative;
                margin-bottom: 0.3rem;
                z-index: 1;
                padding: .3rem;
                &:after{
                    content: " ";
                    width: 1.4rem;
                    height: 0.03rem;
                    background: #ea2228;
                    position: absolute;
                    bottom: 0;
                    left: 0.2rem;
                    z-index: 2;
                }
            }
            img{
                width: 100%;
            }
            .info{
                padding: 0 .3rem;
                p{
                    color: #595757;
                    font-size: .22rem;
                }
            }

        }
    }
</style>